// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 헤더 스타일 */
.app-header {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 40px;
}

.logo {
  font-size: 20px;
  font-weight: bold;
  color: #667eea;
  text-decoration: none;
  white-space: nowrap;
}

.logo:hover {
  color: #5a67d8;
}

.nav-menu {
  display: flex;
  gap: 8px;
}

.nav-link {
  padding: 8px 16px;
  color: #4a5568;
  text-decoration: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.nav-link:hover {
  background: #f7fafc;
  color: #2d3748;
}

.nav-link.active {
  background: #edf2ff;
  color: #667eea;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 사용량 위젯 */
.usage-widget {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
}

.usage-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.usage-label {
  color: #64748b;
  font-weight: 500;
}

.usage-count {
  color: #334155;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.usage-count.low {
  color: #ef4444;
}

.usage-divider {
  width: 1px;
  height: 16px;
  background: #cbd5e1;
}

.usage-refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.usage-refresh-btn:hover {
  background: #e2e8f0;
  color: #475569;
}

.usage-refresh-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.refresh-icon {
  transition: transform 0.3s ease;
}

.refresh-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.user-menu {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
  padding: 8px 12px;
  background: #f7fafc;
  border-radius: 6px;
  cursor: pointer;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s;
}

.user-menu:hover .user-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 10px 16px;
  text-align: left;
  font-size: 14px;
  color: #4a5568;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background: #f7fafc;
  color: #2d3748;
}

.dropdown-item.logout {
  color: #e53e3e;
  border-top: 1px solid #e2e8f0;
}

.dropdown-item.logout:hover {
  background: #fff5f5;
  color: #c53030;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .header-container {
    padding: 0 16px;
  }
  
  .header-left {
    gap: 20px;
  }
  
  .nav-menu {
    display: none;
  }
  
  .logo {
    font-size: 18px;
  }
}

/* 모바일 메뉴 토글 (필요시 구현) */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/header.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* 헤더 스타일 */\n.app-header {\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.header-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 20px;\n  height: 64px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n}\n\n.logo {\n  font-size: 20px;\n  font-weight: bold;\n  color: #667eea;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.logo:hover {\n  color: #5a67d8;\n}\n\n.nav-menu {\n  display: flex;\n  gap: 8px;\n}\n\n.nav-link {\n  padding: 8px 16px;\n  color: #4a5568;\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.nav-link:hover {\n  background: #f7fafc;\n  color: #2d3748;\n}\n\n.nav-link.active {\n  background: #edf2ff;\n  color: #667eea;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* 사용량 위젯 */\n.usage-widget {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.usage-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.usage-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.usage-count {\n  color: #334155;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.usage-count.low {\n  color: #ef4444;\n}\n\n.usage-divider {\n  width: 1px;\n  height: 16px;\n  background: #cbd5e1;\n}\n\n.usage-refresh-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.usage-refresh-btn:hover {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.usage-refresh-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.refresh-icon {\n  transition: transform 0.3s ease;\n}\n\n.refresh-icon.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.user-menu {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-name {\n  font-size: 14px;\n  color: #2d3748;\n  font-weight: 500;\n  padding: 8px 12px;\n  background: #f7fafc;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  min-width: 160px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.2s;\n}\n\n.user-menu:hover .user-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 10px 16px;\n  text-align: left;\n  font-size: 14px;\n  color: #4a5568;\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dropdown-item:hover {\n  background: #f7fafc;\n  color: #2d3748;\n}\n\n.dropdown-item.logout {\n  color: #e53e3e;\n  border-top: 1px solid #e2e8f0;\n}\n\n.dropdown-item.logout:hover {\n  background: #fff5f5;\n  color: #c53030;\n}\n\n/* 모바일 반응형 */\n@media (max-width: 768px) {\n  .header-container {\n    padding: 0 16px;\n  }\n  \n  .header-left {\n    gap: 20px;\n  }\n  \n  .nav-menu {\n    display: none;\n  }\n  \n  .logo {\n    font-size: 18px;\n  }\n}\n\n/* 모바일 메뉴 토글 (필요시 구현) */\n.mobile-menu-toggle {\n  display: none;\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .mobile-menu-toggle {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
